import React from 'react';
import { getAppVersion } from '../../helpers/version';

function FooterComponent() {
    const version = getAppVersion();
    
    return (
        <div id="footer">
            {version && (
                <small className="footer-version">v{version}</small>
            )}
            <small className="font-weight-bold">En tjeneste levert av Touch Soft AS</small>
        </div>
    );
}


export { FooterComponent };